import { IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { useTheme } from '@emotion/react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

export default function SubjectOfReportCard({ data }) {
  const theme = useTheme();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const {t} = useTranslation()

  const handleDownload = async () => {
    try {
      const response = await fetch(data?.attachement);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const name = data?.attachement?.split('/').pop();
      link.download = `${name}`;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading image:', error);
    }
  };

  return (
    <Stack
      style={{ borderBottomWidth: '1px', borderColor: '#14285A1A', borderTopWidth: '1px' }}
      className="py-[16px]"
    >
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Typography
          className="fw-medium ff-Roboto fs-14"
          color={text}
        >
          {data?.subject}
        </Typography>
        <Typography
          className="fw-regular ff-Roboto fs-12"
          color={textLight}
        >
          {moment(data?.createdOn).format('DD-MMM-YYYY')}
        </Typography>
      </Stack>
      <Stack>
        <Typography
          className="fw-regular ff-Roboto fs-12 !mt-[8px]"
          color={'#14285AB3'}
        >
          {data?.message}
        </Typography>
      </Stack>
      <Stack
        direction={'row'}
        alignItems={'center'}
        className="mt-[18px] cursor-pointer"
        sx={{ color: '#14285AB3', fontSize: '14px'}}
        onClick={() => handleDownload()}
      >
        <SaveAltIcon style={{ marginRight: '16px', width: '18px' , height: '18px' }} />
        <Typography
          className="fw-medium ff-Roboto fs-14 !uppercase"
          color={'#14285AB3'}
        >
          {t('Download')}
        </Typography>
      </Stack>
    </Stack>
  );
}
